webpackJsonp([35783957827783],{

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _playerSummaryModule = __webpack_require__(297);
	
	var _playerSummaryModule2 = _interopRequireDefault(_playerSummaryModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerData = {
	  "player": {
	    "location": "Denver, CO",
	    "skills": ["html", "css", "javascript", "node", "react", "wordpress", "mysql", "php", "python"],
	    "specialMoves": ["fat arrow of reckoning", "cyclonic string interpolation", "prototype haste", "npm fire"]
	  }
	};
	
	var PlayerSummary = function PlayerSummary() {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: _playerSummaryModule2.default.playerSummary
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        className: _playerSummaryModule2.default.statRow
	      },
	      _react2.default.createElement(
	        'span',
	        {
	          className: _playerSummaryModule2.default.statLabel
	        },
	        'Location:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _playerSummaryModule2.default.stat },
	        playerData.player.location
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: _playerSummaryModule2.default.statRow
	      },
	      _react2.default.createElement(
	        'span',
	        {
	          className: _playerSummaryModule2.default.statLabel
	        },
	        'Skills:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _playerSummaryModule2.default.stat },
	        _react2.default.createElement(
	          'ul',
	          {
	            className: _playerSummaryModule2.default.statList
	          },
	          playerData.player.skills.map(function (skill) {
	            return _react2.default.createElement(
	              'li',
	              {
	                key: skill,
	                className: _playerSummaryModule2.default.skill
	              },
	              skill
	            );
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: _playerSummaryModule2.default.statRow
	      },
	      _react2.default.createElement(
	        'span',
	        {
	          className: _playerSummaryModule2.default.statLabel
	        },
	        'Special moves:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _playerSummaryModule2.default.stat },
	        _react2.default.createElement(
	          'ul',
	          {
	            className: _playerSummaryModule2.default.specialMoveList
	          },
	          playerData.player.specialMoves.map(function (specialMove) {
	            return _react2.default.createElement(
	              'li',
	              {
	                key: specialMove,
	                className: _playerSummaryModule2.default.specialMove
	              },
	              specialMove
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = PlayerSummary;
	module.exports = exports['default'];

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"playerSummary":"src-components----player-summary-module---playerSummary---2dwBA","statRow":"src-components----player-summary-module---statRow---CwoN7","statLabel":"src-components----player-summary-module---statLabel---QWvOM","stat":"src-components----player-summary-module---stat---11pU7","statList":"src-components----player-summary-module---statList---BgWkb","specialMoveList":"src-components----player-summary-module---specialMoveList---2Ud3F","skill":"src-components----player-summary-module---skill---2TS3d"};

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(152);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _playerSummary = __webpack_require__(199);
	
	var _playerSummary2 = _interopRequireDefault(_playerSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Web Developer'
	    ),
	    _react2.default.createElement(_playerSummary2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-db382ba04aa03be51453.js